module.exports = __webpack_public_path__ + "img/panorama_horizontal.5dc40681.svg";